module.exports = __webpack_public_path__ + "img/tinderella.12365c52.svg";